import { createSlice } from '@reduxjs/toolkit';

export const MODEL_UPLOAD_TYPE = {
  REQUEST: 1,
  UPLOAD: 2,
};

const upload3DModelProduct = createSlice({
  name: 'upload3DModelProduct',
  initialState: {
    data: null,
    product3DModelUnitySceneLoaded: false,
    product3DModelAssetLoaded: false,
  },
  reducers: {
    show: (state, { payload }) => {
      state.data = payload;
    },
    close: (state) => {
      state.data = null;
    },
    setProduct3DModelUnitySceneLoaded: (state, { payload }) => {
      state.product3DModelUnitySceneLoaded = payload;
    },
    setProduct3DModelAssetLoaded: (state, { payload }) => {
      state.product3DModelAssetLoaded = payload;
    },
  },
});

export const upload3DModelProductActions = upload3DModelProduct.actions;
export const upload3DModelProductReducer = upload3DModelProduct.reducer;
export default upload3DModelProductReducer;

export const selectUpload3DModelProductShow = (state) => state.upload3DModelProduct.data;
export const selectProduct3DModelUnitySceneLoaded = (state) =>
  state.upload3DModelProduct.product3DModelUnitySceneLoaded;
export const selectProduct3DModelAssetLoaded = (state) =>
  state.upload3DModelProduct.product3DModelAssetLoaded;